import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { track } from "@amplitude/analytics-browser";

const DEBOUNCE_MS = 500;

export function useSearchKeyword() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialKeyword = searchParams.get("keyword") || "";
  const [keyword, setKeyword] = useState(initialKeyword);
  const [debouncedKeyword, setDebouncedKeyword] = useState(initialKeyword);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedKeyword(keyword);
      if (keyword) {
        setSearchParams({ keyword }, { replace: true });
        if (debouncedKeyword) {
          track("검색 페이지 디바운스에 의한 검색", {
            keyword: debouncedKeyword,
          });
        }
      } else {
        setSearchParams({}, { replace: true });
      }
    }, DEBOUNCE_MS);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  return { keyword, setKeyword, debouncedKeyword };
}
